import { getClaimById } from '@zurich/api/claim';
import { useApiQuery, useTranslation } from '@zurich/common/hooks';
export const useGetClaim = (claimNo) => {
    const { t } = useTranslation();
    return useApiQuery({
        request: getClaimById,
        params: { vars: { claimNumber: claimNo ?? '' } },
        options: { errorText: t('claim.notFoundError') },
        queryKey: [claimNo ?? 'getClaimById'],
        queryOptions: {
            enabled: !!claimNo,
        },
    });
};
